import React from 'react'

import PersonIcon from '@mui/icons-material/Person'
import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import styles from '../../../constants/styles'

export const Username = () => (
  <PersonIcon sx={{ color: styles.colors.darkGrey }} />
)

export const FormInputUnavailable = (props) => (
  <CloseIcon sx={{ color: styles.colors.darkGrey }} {...props} />
)

export const FormInputAvailable = (props) => (
  <CheckIcon sx={{ color: styles.colors.vegan }} {...props} />
)
